import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
// import HuggingFace from "../../../assets/Integrations/icons/huggingface.svg";
import Foundation2_2HD from "../../../assets/Models/images/foundation-2_2_hd.png";
import Foundation2_3 from "../../../assets/Models/images/foundation-2_3.png";
import Foundation2_3Fast from "../../../assets/Models/images/foundation-2_3_fast.png";
import Foundation2_3Inpainting from "../../../assets/Models/images/foundation-2_3_inpainting.png";
import Foundation3_1 from "../../../assets/Models/images/foundation-3_1.png";
import Foundation3_2 from "../../../assets/Models/images/foundation-3_2.png";
import Foundation4B_Adapt from "../../../assets/Models/images/foundation-4b_adapt.png";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../components/common/BriaButtonGroup/BriaButtonGroup";
import LinkConstants from "../../../constants/LinkConstants";
import HuggingFace from "../../../assets/images/icons/HuggingFace";

const ModelsFoundation = () => {
	const { t } = useTranslation("translation", { keyPrefix: "models.foundation" });

	const openDocs = (link: string) => window.open(link, "_blank");

	const foundationModelsCards: ConsoleAPICardProps[] = [
		{
			image: Foundation3_2,
			header: t("cards.3_2.header"),
			description: t("cards.3_2.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_2"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace/>}
					>
						{t("cards.3_2.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_2"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.3_2.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Foundation3_1,
			header: t("cards.3_1.header"),
			description: t("cards.3_1.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_1"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace/>}
					>
						{t("cards.3_1.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["3_1"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.3_1.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Foundation4B_Adapt,
			header: t("cards.4b_adapt.header"),
			description: t("cards.4b_adapt.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["4B_ADAPT"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("cards.4b_adapt.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["4B_ADAPT"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.4b_adapt.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["4B_ADAPT"].HUGGING_FACE.DEMO)}
					>
						{t("cards.4b_adapt.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: Foundation2_3,
			header: t("cards.2_3.header"),
			description: t("cards.2_3.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_3"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_3.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_3"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_3.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Foundation2_3Fast,
			header: t("cards.2_3_fast.header"),
			description: t("cards.2_3_fast.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_3_FAST"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_3_fast.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_3_FAST"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_3_fast.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Foundation2_2HD,
			header: t("cards.2_2_hd.header"),
			description: t("cards.2_2_hd.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_2_HD"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_2_hd.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_2_HD"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_2_hd.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Foundation2_3Inpainting,
			header: t("cards.2_3_inpainting.header"),
			description: t("cards.2_3_inpainting.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_3_INPAINTING"].HUGGING_FACE.MODEL)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_3_inpainting.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.FOUNDATION["2_3_INPAINTING"].HUGGING_FACE.DEMO)}
						startIcon={<HuggingFace />}
					>
						{t("cards.2_3_inpainting.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")} hideCopyTokenBtn>
			<ConsoleAPICards cards={foundationModelsCards} />
		</ConsoleAPILayout>
	);
};

export default observer(ModelsFoundation);
